import { useEffect, useState } from "react";
import { fetchUserAttendance } from "../Api/ViewUserAttendance";
import { Container, Table } from "react-bootstrap";

//import "../Styling/ViewUserAttendance.css";
import { toast } from "react-toastify";
import moment from "moment";

const ViewUserAttendance = () => {
  const [attendance, setAttendance] = useState([]);

  useEffect(() => {
    const loadAttendance = async () => {
      try {
        const data = await fetchUserAttendance();
        setAttendance(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching User Attendance`);
      }
    };

    loadAttendance();
  }, []);

  return (
    
      <div className="main-content expand">
        <Container fluid className="list-container">
          <span className="list-title">View User Attendance</span>

          {attendance.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Attendance ID</th>
                      <th>Working Days ID</th>
                      <th>Resource ID</th>
                      <th>Salary Days</th>
                      <th>Payroll ID</th>
                      <th>Created At</th>
                      <th>Created By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {attendance.map((record, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{record.attendenceId}</td>
                        <td>{record.workingDaysId}</td>
                        <td>{record.resourceId}</td>
                        <td>{record.salaryDays}</td>
                        <td>{record.payrollid}</td>
                        <td>
                          {record.createdAt 
                            ? moment(record.createdAt).format('L') + ' at ' + moment(record.createdAt).format('LTS')
                            : 'N/A'}
                        </td>
                        <td>{record.createdBy || 'N/A'}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No attendance records found.</p>
          )}
        </Container>
      </div>
    
  );
};

export default ViewUserAttendance;